import styled from 'styled-components';

export const ListEmpty = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	height: calc(100vh - 30rem);
`;
export const Wrapper = styled.div`
	width: 100%;
`;
